import { ArquivamentoSolic } from "./ArquivamentoSolicVistoria";

export default ArquivamentoSolic;